import React from "react";

import ProductGrid from "../components/ProductGrid/ProductGrid";
import { Link } from "react-router-dom";
const Products = () => {
  return (
    <div>
      <section className="product-hero">
        <div className="hero-content">
          <h1>Premium Quality Frozen Food & Agricultural Products</h1>
          <p>
            Delivering Grade-A Frozen Chicken, Beef, Rice, Sugar, Wheat & Other
            Food Essentials to Importers Worldwide.
          </p>
        </div>
      </section>
      <div className="main-section">
        <ProductGrid />
      </div>
      <section className="delivery-section">
        <h2>Reliable Containerized Marine Delivery to 50+ Ports Globally</h2>
        <Link to={"/delivery"}>
          <button className="primary-btn">Check Our Delivery Routes</button>
        </Link>
      </section>
    </div>
  );
};

export default Products;
